import { Injectable } from '@angular/core';

/** Dynamic group key derived from API activity type / groupName. */
export type ActivityCategory = string;

export interface Activity {
  id: string;
  name: string;
  category: ActivityCategory;
  image: string;
}

@Injectable({
  providedIn: 'root',
})
export class ActivitySelectionService {
  private readonly selectedActivities = new Set<string>();
  private currentUserId: string | number | null = null;

  /**
   * Initialize or check if user has changed
   * Clears selections if a different user is detected
   */
  initializeForUser(userId: string | number | null | undefined): void {
    if (userId !== this.currentUserId) {
      // User has changed, clear previous selections
      this.selectedActivities.clear();
      this.currentUserId = userId ?? null;
    }
  }

  toggleActivity(activityId: string): void {
    if (this.selectedActivities.has(activityId)) {
      this.selectedActivities.delete(activityId);
    } else {
      this.selectedActivities.add(activityId);
    }
  }

  isActivitySelected(activityId: string): boolean {
    return this.selectedActivities.has(activityId);
  }

  getSelectedActivities(): string[] {
    return Array.from(this.selectedActivities.values());
  }

  /**
   * Replace current selections (optionally for a specific user)
   */
  setSelectedActivities(activityIds: string[], userId?: string | number | null): void {
    this.initializeForUser(userId ?? null);
    this.selectedActivities.clear();
    activityIds.forEach(id => this.selectedActivities.add(id));
  }

  clearSelection(): void {
    this.selectedActivities.clear();
    this.currentUserId = null;
  }

  hasSelectedActivities(): boolean {
    return this.selectedActivities.size > 0;
  }
}

